import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Moon, ShoppingBag, Sparkles } from 'lucide-react';
const achievements = [{
  icon: <Sparkles className="w-6 h-6 text-sage-600" data-id="element-218" />,
  title: 'Fase de Rescate (Días 1-7)',
  description: 'El "vaciado" inicial donde notarás ligereza en tus manos, pies y abdomen.'
}, {
  icon: <ShieldCheck className="w-6 h-6 text-sage-600" data-id="element-219" />,
  title: 'Reconstrucción (Días 8-21)',
  description: 'Sellado de la barrera intestinal para eliminar los gases y la neblina mental.'
}, {
  icon: <Moon className="w-6 h-6 text-sage-600" data-id="element-220" />,
  title: 'Ritual de Sueño',
  description: 'Cómo hackear tu descanso para que tu cuerpo se desinflame mientras duermes.'
}, {
  icon: <ShoppingBag className="w-6 h-6 text-sage-600" data-id="element-221" />,
  title: 'Guía de Compras',
  description: 'Qué elegir en el supermercado argentino para no fallar nunca.'
}];
export function WhatYoullAchieve() {
  return <section className="py-10 md:py-28 bg-cream-100" data-id="element-222">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-223">
        <FadeIn data-id="element-224">
          <div className="text-center mb-16" data-id="element-225">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-4" data-id="element-226">
              Qué vas a lograr en 21 días
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-227">
          {achievements.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-228">
              <div className="flex gap-6 p-6 rounded-2xl bg-white shadow-sm border border-cream-200 hover:border-sage-300 transition-colors duration-300" data-id="element-229">
                <div className="flex-shrink-0" data-id="element-230">
                  <div className="w-12 h-12 rounded-full bg-sage-100 flex items-center justify-center" data-id="element-231">
                    {item.icon}
                  </div>
                </div>
                <div data-id="element-232">
                  <h3 className="text-xl font-bold text-charcoal mb-2 font-sans" data-id="element-233">
                    {item.title}
                  </h3>
                  <p className="text-charcoal-light leading-relaxed" data-id="element-234">
                    {item.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}